import { dataTypes } from "@/constant/global-data.js";

const columns = [
  {
    title: "序号",
    dataIndex: "sn",
    key: "sn",
    width: 70,
    fixed: "left"
  },
  {
    title: "编码",
    dataIndex: "identifier",
    key: "identifier",
    ellipsis: true
  },
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
    ellipsis: true
  },
  {
    title: "描述",
    dataIndex: "description",
    key: "description",
    ellipsis: true
  },
  // {
  //   title: "类别",
  //   dataIndex: "description",
  //   key: "description",
  //   ellipsis: true
  // },
  {
    title: "数据类型",
    dataIndex: "dataType",
    key: "dataType",
    filters: dataTypes,
    ellipsis: true
  },
  // {
  //   title: "所属功能",
  //   dataIndex: "function",
  //   key: "function",
  //   ellipsis: true
  // },

  {
    title: "操作",
    dataIndex: "operate",
    key: "operate",
    fixed: "right",
    width: 180
  }
];

const menuList = [
  { name: "自定义属性", key: "custom" },
  { name: "标准属性", key: "standard" }
];

export { columns, menuList };
